import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/codebuild/output/src3551364499/src/zeronet-web/layouts/default.vue")),
  embed: defineAsyncComponent(() => import("/codebuild/output/src3551364499/src/zeronet-web/layouts/embed.vue"))
}